import type {
  CarrierRequestItem,
  CarrierRequestPending,
  CarrierRequestsHandlers,
} from '../model/types'
import { CarrierIdentity } from './carrier-identity'
import { RequestActions } from './request-actions'
import { RequestPickupDelivery } from './request-pickup-delivery'
import { RequestPrice } from './request-price'
import { RequestStatusBanner } from './request-status-banner'

interface RequestRowProps {
  request: CarrierRequestItem
  distanceMiles?: number
  handlers: CarrierRequestsHandlers
  pending?: CarrierRequestPending | null
}

export function RequestRow({
  request,
  distanceMiles,
  handlers,
  pending,
}: RequestRowProps) {
  return (
    <article className="flex flex-col gap-3 border-b border-gray-200 px-5 py-5 last:border-b-0">
      <RequestStatusBanner request={request} />
      <div className="flex flex-col gap-4 lg:flex-row lg:items-start lg:gap-6">
        <div className="min-w-0 flex-1">
          <CarrierIdentity
            carrier={request.carrier}
            requestedAt={request.requestedAt}
            onOpenCarrier={
              handlers.onOpenCarrier
                ? () => handlers.onOpenCarrier?.(request.id)
                : undefined
            }
          />
        </div>
        <div className="lg:w-37.5 lg:shrink-0">
          <RequestPickupDelivery dates={request.dates} />
        </div>
        <PriceCell request={request} />
        <div className="lg:w-45 lg:shrink-0">
          <RequestActions
            requestId={request.id}
            status={request.status}
            matchesCarrierPay={request.matchesCarrierPay}
            brokerCounterPrice={request.brokerCounterPrice}
            distanceMiles={distanceMiles}
            handlers={handlers}
            pending={pending}
          />
        </div>
      </div>
    </article>
  )
}

function PriceCell({ request }: { request: CarrierRequestItem }) {
  // The empty spacer only reserves the desktop column; on mobile it would just
  // add a blank stacked row, so hide it there.
  if (!request.price) return <div className="hidden lg:block lg:w-27.5" />
  return (
    <div className="flex flex-col items-start lg:w-27.5 lg:shrink-0">
      <RequestPrice price={request.price} />
    </div>
  )
}
